import "./features.css";

const Features = () => {
    
    const keyFeatures = [
        {
            title: "Wide Range of Products",
            description: "Oils, greases, hydraulic fluids, and specialized lubricants for every application."
        },
        {
            title: "Industry Expertise",
            description: "Trusted by manufacturers, heavy machinery operators, and maintenance professionals."
        }, 
        {
            title: "Quality & Performance",
            description: "Superior formulations designed to enhance machinery longevity and efficiency."
        }
    ];
    
    return(
        <div className="features-container">
            <h2>Key Features</h2>
            <p className="general-header">Optimize your business operations with the best in lubrication techonology - only at Southzone Industrial Lubricants</p>
            <div className="features-card-container">
                {
                    keyFeatures.map((feature, index) => (
                    <div className="product-card" key={index}>
                        <h3>{feature.title}</h3>
                        <hr />
                        <p>{feature.description}</p>
                    </div>)
                    )
                }
            </div>
        </div>
    );
};

export default Features;